<template>

  <el-dialog
      title="修改手机号"
      :modelValue="modelValue"
      @update:modelValue='update'
      width="600px"
      :close-on-click-modal="false"
      append-to-body
  >
  <div class="content">
    <div style="text-align: center"  v-if="isQrcode">
      <el-image :src="verifyPhoneData.qrcodeUrl"></el-image>
      <span style="text-align: center;width: 100%;color: red;font-size: 16px">请扫描上方二维码，进行实名认证</span>
    </div>
    <el-form
        ref="formRef"
        :model="phoneData"
        :rules="rules"
        label-width="120px"
        class="demo-ruleForm"
        v-else
    >
      <el-form-item label="输入新手机号" prop="tel">
        <el-input v-model="phoneData.tel" />
      </el-form-item>
      <el-form-item label="输入验证码" prop="code">
        <el-input v-model="phoneData.code" style="width: 50%" />
        <el-button
            v-show="sendAuthCode"
            class="auth_text auth_text_blue"
            style="margin-left: 10px"
            type="primary"
            @click="sendAuthCode"
            v-if="isSend"
        >获取验证码</el-button>
        <el-button
            v-else
            class="auth_text"
            :disabled="true"
            style="margin-left: 10px"
        >
          <span class="auth_text_blue">{{ timer }} </span>秒后可重新发送</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">提交</el-button>
        <el-button type="info" @click="resetForm('resetForm')">重置</el-button>
      </el-form-item>
    </el-form>

  </div>


  </el-dialog>
</template>
<script setup>
import {ref} from "vue";
import {ElMessage} from "element-plus";
import {resetPhone, sendVerCode, verifydetectauthinfo, verifyUpdatePhone} from "../../../api/mine";

const props = defineProps({modelValue:Boolean,isVerification:String});
const emit=defineEmits(["update"])
const update = ()=>{
  emit('update:modelValue', false)
}
const phoneData=ref({
  tel:'',
  code:'',
})

const timer=ref(60)
const isSend=ref(true)
const  getAuthCode=()=> {
  isSend.value=false
  timer.value = 60
  const countDown= setInterval(() => {
    timer.value--
    if (timer.value <= 0) {
      isSend.value = true
      clearInterval(countDown)
    }
  }, 1000)
}
const sendAuthCode=()=> {
    if(phoneData.value.tel==""){
      ElMessage.error("请输入手机号")
      return
    }
    sendVerCode({
      tel:phoneData.value.tel
    }).then(res=>{
      if(!res.success){
        ElMessage.error(res.msg)
      }
    })
  getAuthCode()
}
const formRef=ref()
const rules=ref({
  tel:[
    { required: true, message: '请输入手机号', trigger: 'blur' },
  ],
  code:[
    { required: true, message: '请输入验证码', trigger: 'blur' },
  ],
})

let qrcodeInterval;

const refreshCode=()=>{
  qrcodeInterval = setInterval(() => {
    verifydetectauthinfo({ token: verifyPhoneData.value.token }).then(res=>{
      if (res.success) {
        ElMessage.success(res.message)
        isQrcode.value = false
        emit('update:modelValue', false)
        emit('success')
        clearInterval(qrcodeInterval)
      }
    })
  }, 2000)
}
const isQrcode=ref(false)
const verifyPhoneData=ref({
  token:'',
  qrcodeUrl:''
})
const qrcodeUrl=ref("")
const submitForm=()=>{
  formRef.value.validate(async(valid) => {
    if (valid) {
      // 已经认证
      if(props.isVerification!=""){
        console.log(props.isVerification)
        verifyUpdatePhone({
          code:phoneData.value.code,
          mobile:phoneData.value.tel
        }).then(res=>{
          if(res.success){
            ElMessage.success(res.message)
            emit('update:modelValue', false)
            emit('success')

          }else {
            ElMessage.success(res.message)
          }
        })
      }else {
        resetPhone(phoneData.value).then(({ success, message, datas }) => {
          if (!success) {
            ElMessage.error(message)
          }
          if (message === '实名制认证') {
            isQrcode.value=true
            verifyPhoneData.value.qrcodeUrl = datas.QrCode
            verifyPhoneData.value.token = datas.token
            refreshCode()
          }
        })
      }

    }
  })
}
</script>
<style scoped>
  .content{
    margin: 0 40px;
  }
</style>